import Vue from "vue";
import VueCookies from "vue-cookies";
import VueClipboard from "vue-clipboard2";
import "xe-utils";
import VXETable from "vxe-table";
import VueI18n from "vue-i18n";
import enUS from "vxe-table/lib/locale/lang/en-US";
import "vxe-table/lib/index.css";
import App from "./App.vue";
import router from "./router";
import VTooltip from "v-tooltip";
//import VModal from "vue-js-modal";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { store } from "./store/store";
import OpenIndicator from "./components/common/CustomSelect/OpenIndicator.vue";
import Deselect from "./components/common/CustomSelect/Deselect.vue";
import anchorUIAsPlugin from "@anchor/ui-components";
import VueSanitize from "vue-sanitize";

import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme

Vue.use(VueQuillEditor /* { default global options } */);

// Importing Vue Select & Registering the Component
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
vSelect.props.components.default = () => ({ OpenIndicator, Deselect });
Vue.component("VSelect", vSelect);

import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(VueLoading);

Vue.use(Toast, {
  closeButton: false,
  icon: false,
  timeout: 5000,
  hideProgressBar: true,
});

Vue.use(VTooltip);

Vue.use(VueClipboard);

Vue.config.productionTip = false;

Vue.use(VueCookies);

Vue.$cookies.config("disputesagent");

Vue.use(VueI18n);

const messages = {
  en_US: {
    ...enUS,
  },
};

const i18n = new VueI18n({
  locale: "en_US",
  messages,
});

Vue.use(VXETable, {
  i18n: (key, args) => i18n.t(key, args),
});
12;

Vue.use(anchorUIAsPlugin);
Vue.use(VueSanitize);
//Vue.use(VModal);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
